import { useState } from 'react';

const useIsProcessing = (defaultValue: boolean = false) => {
    const [isProcessing, setIsProcessing] = useState(defaultValue);

    const onSetIsProcessing = (value: boolean) => {
        setIsProcessing(value);
    };

    return {
        isProcessing,
        onSetIsProcessing
    };
};

export default useIsProcessing;
